import { IEditSubcategoryContext } from './editSubcategoryContext';

export enum EditSubcategoryActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_ALL_DATA = 'SET_ALL_DATA',
	CHANGE_LOADER_STATUS = 'CHANGE_LOADER_STATUS',
	SET_FILE_ID = 'SET_FILE_ID',
	DELETE_PHOTO = 'DELETE_PHOTO',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_FETCHED_RESTAURANTS = 'SET_FETCHED_RESTAURANTS',
	SET_IDS_RESTAURANT = 'SET_IDS_RESTAURANT',
	CHANGE_NAME_OF_SUBCATEGORY = 'CHANGE_NAME_OF_SUBCATEGORY',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	TOGGLE_HAS_SCHEDULE_PRIORITY = 'TOGGLE_HAS_SCHEDULE_PRIORITY',
	CHANGE_ACTIVATION_SCHEDULE = 'CHANGE_ACTIVATION_SCHEDULE',
	CHANGE_DEACTIVATION_SCHEDULE = 'CHANGE_DEACTIVATION_SCHEDULE',
	SET_DEFAULT_CUSTOMER_LANGUAGE = 'SET_DEFAULT_CUSTOMER_LANGUAGE',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: EditSubcategoryActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IEditSubcategoryContext['needRefetchData'];
	};
}

interface ISetAllData {
	type: EditSubcategoryActionTypes.SET_ALL_DATA;
	payload: {
		filePath: IEditSubcategoryContext['filePath'];
		subcategoryID: IEditSubcategoryContext['subcategoryID'];
		initialIDSelectedCustomer: IEditSubcategoryContext['initialIDSelectedCustomer'];
		initialIDsSelectedRestaurant: IEditSubcategoryContext['initialIDsSelectedRestaurant'];
		nameOfSubcategory: IEditSubcategoryContext['nameOfSubcategory'];
		initialIDSelectedCategory: IEditSubcategoryContext['initialIDSelectedCategory'];
		hasSchedulePriority: IEditSubcategoryContext['hasSchedulePriority'];
		activationSchedule: IEditSubcategoryContext['activationSchedule'];
		deactivationSchedule: IEditSubcategoryContext['deactivationSchedule'];
		translations: IEditSubcategoryContext['translations'];
	};
}

interface IChangeLoaderStatus {
	type: EditSubcategoryActionTypes.CHANGE_LOADER_STATUS;
	payload: {
		isLoading: IEditSubcategoryContext['isLoading'];
	};
}

interface ISetFileId {
	type: EditSubcategoryActionTypes.SET_FILE_ID;
	payload: {
		fileId: IEditSubcategoryContext['fileId'];
	};
}

interface IDeletePhoto {
	type: EditSubcategoryActionTypes.DELETE_PHOTO;
}

interface ISetFetchedCustomers {
	type: EditSubcategoryActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IEditSubcategoryContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: EditSubcategoryActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IEditSubcategoryContext['IDSelectedCustomer'];
	};
}

interface ISetFetchedRestaurants {
	type: EditSubcategoryActionTypes.SET_FETCHED_RESTAURANTS;
	payload: {
		fetchedRestaurants: IEditSubcategoryContext['fetchedRestaurants'];
	};
}

interface ISetIDsRestaurant {
	type: EditSubcategoryActionTypes.SET_IDS_RESTAURANT;
	payload: {
		IDsSelectedRestaurant: IEditSubcategoryContext['IDsSelectedRestaurant'];
	};
}

interface IChangeNameOfSubcategory {
	type: EditSubcategoryActionTypes.CHANGE_NAME_OF_SUBCATEGORY;
	payload: {
		nameOfSubcategory: IEditSubcategoryContext['nameOfSubcategory'];
	};
}

interface ISetFetchedCategories {
	type: EditSubcategoryActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		fetchedCategories: IEditSubcategoryContext['fetchedCategories'];
	};
}

interface ISetIDCategory {
	type: EditSubcategoryActionTypes.SET_ID_CATEGORY;
	payload: {
		IDSelectedCategory: IEditSubcategoryContext['IDSelectedCategory'];
	};
}

interface IToggleHasSchedulePriority {
	type: EditSubcategoryActionTypes.TOGGLE_HAS_SCHEDULE_PRIORITY;
}

interface IChangeActivationSchedule {
	type: EditSubcategoryActionTypes.CHANGE_ACTIVATION_SCHEDULE;
	payload: {
		activationSchedule: IEditSubcategoryContext['activationSchedule'];
	};
}

interface IChangeDeactivationSchedule {
	type: EditSubcategoryActionTypes.CHANGE_DEACTIVATION_SCHEDULE;
	payload: {
		deactivationSchedule: IEditSubcategoryContext['deactivationSchedule'];
	};
}

interface ISetDefaultCustomerLanguage {
	type: EditSubcategoryActionTypes.SET_DEFAULT_CUSTOMER_LANGUAGE;
	payload: {
		defaultCustomerLanguage: IEditSubcategoryContext['defaultCustomerLanguage'];
	};
}

interface ISetTranslationTab {
	type: EditSubcategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		selectedTranslationTab: IEditSubcategoryContext['selectedTranslationTab'];
	};
}

interface IChangeTranslation {
	type: EditSubcategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		translations: IEditSubcategoryContext['translations'];
	};
}

interface ISetDataForSubmit {
	type: EditSubcategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IEditSubcategoryContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: EditSubcategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IEditSubcategoryContext['typeOfModalWindow'];
	};
}

export type TEditSubcategoryAction =
	| IRefetchData
	| ISetAllData
	| IChangeLoaderStatus
	| ISetFileId
	| IDeletePhoto
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetFetchedRestaurants
	| ISetIDsRestaurant
	| IChangeNameOfSubcategory
	| ISetFetchedCategories
	| ISetIDCategory
	| IToggleHasSchedulePriority
	| IChangeActivationSchedule
	| IChangeDeactivationSchedule
	| ISetDefaultCustomerLanguage
	| ISetTranslationTab
	| IChangeTranslation
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
